// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","name":"Footer_name__xI97K"};